import PropTypes from 'prop-types';
import React from 'react';

import { LocaleService } from '@sm360/widget-commons-core-services';

import 'commons-vehicle/Vehicle/components/CallToAction/ViewAllInventory/ViewAllInventoryCTA.scss';

const ViewAllInventoryCTA = ({ buttonClass, redirection }) => {
    const currentClass = [buttonClass, 'vehicle-cta-btn', 'view-all-inventory'];
    return (
        // Redirect to the link from Contentzone
        <a href={redirection} target="_blank" className={currentClass.join(' ')} rel="noreferrer">
            <span>{LocaleService.t('CALL_TO_ACTION.BTN_VIEW_ALL_INVENTORY_TEXT')}</span>
        </a>
    );
};

ViewAllInventoryCTA.defaultProps = {
    buttonClass: 'sr-button-1',
    redirection: '',
};

ViewAllInventoryCTA.propTypes = {
    buttonClass: PropTypes.string,
    redirection: PropTypes.string,
};

ViewAllInventoryCTA.displayName = 'ViewAllInventoryCTA';

export default ViewAllInventoryCTA;
